<template>
  <div>
    <CCard>
      <CTabs>
        <CTab
          :title="$t('role.logistics.Connections.Sales.tab')"
          v-if="showProducer"
        >
          <ConnectionsProducer />
        </CTab>
        <CTab
          :title="$t('role.logistics.Connections.Delivery.tab')"
          v-if="showIsland"
        >
          <ConnectionsIsland />
        </CTab>
      </CTabs>
    </CCard>
  </div>
</template>

<script>
import ConnectionsProducer from "./ConnectionsProducer";
import ConnectionsIsland from "./ConnectionsIsland";
import ConnectionsMarketProducer from "./ConnectionsMarketProducer";
import ConnectionsMarketIsland from "./ConnectionsMarketIsland";

export default {
  name: "ProfileData",
  data() {
    return {
      activeTab: 0,
      wallet: null,
      role: null,
    };
  },
  computed: {
    showProducer() {
      if ([1, 2, 3].includes(this.$store.state.role.r_type)) {
        return true;
      }
      return false;
    },
    showIsland() {
      if ([1, 3, 4].includes(this.$store.state.role.r_type)) {
        return true;
      }
      return false;
    },
  },
  components: {
    ConnectionsProducer,
    ConnectionsIsland,
    ConnectionsMarketProducer,
    ConnectionsMarketIsland,
  },
};
</script>
